
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curso/aula/[classroom]",
      function () {
        return require("private-next-pages/curso/aula/[classroom]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curso/aula/[classroom]"])
      });
    }
  